/** @file Resolves one input influence list per vertex for mesh.setWeights (count-checked, normalized). */
import type { Id, MeshAtt } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import type { CommandContext } from '../commandContext';
import { resolveVertexWeights } from './resolveVertexWeights';

/** lists[v] resolved and normalized; VALIDATION at `weights` for a wrong list count, at `weights.<v>` for a vertex without weight > 0. */
export function resolveAllWeights(ctx: CommandContext, mesh: MeshAtt, lists: readonly (readonly (readonly [string, number])[])[]): [Id, number][][] {
  const count = mesh.uvs.length / 2;
  if (lists.length !== count) throwError('VALIDATION', undefined, { path: 'weights', hint: `expected ${count} influence lists (one per vertex), got ${lists.length}` });
  return lists.map((pairs, v) => resolveVertexWeights(ctx, pairs, `weights.${v}`));
}
